/**
 * True if the provided value is null or a string of only whitespace
 * @param value The value to check
 */
export function isBlank(value: unknown): boolean {
    return value == null || (typeof value === 'string' && value.trim().length === 0);
}
